module.exports = __webpack_public_path__ + "img/upload_img_bg01.b6295e95.png";